import { Component, Optional, Inject } from '@angular/core';
import { BaseComponent } from '../shared/base-components/base.component';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { CustomerPurgeService } from './customer-purge.service';

@Component({
    selector: 'customer-purge-modal',
    templateUrl: './customer-purge.modal.html'
})

export class CustomerPurgeWindow extends BaseComponent {
    public batchJobStepDetails;
    public batchJobExceptionDetails;
    public batchJobName: string;
    public isDisable = true;
    public showMessage = false;
    public customerNumberId: number;
    public showSuccessMessage = false;

    constructor(public dialogRef: MatDialogRef<CustomerPurgeWindow>
        , public customerPurgeService: CustomerPurgeService ) {
        super();
    }

    ngOnInit() {

    }

    customerSelected(event) {
        this.isDisable = true;
        this.customerPurgeService.isPseudoCustomer(event.customerNumber).subscribe(
            res => {
                if (res.result) {
                    this.isDisable = false;
                    this.customerNumberId = event.customerNumber;
                } else {
                    this.showMessage = true;
                }
            }
        );
    }

    purgeCustomer() {
        this.customerPurgeService.purgeCustomer(this.customerNumberId).subscribe(
            res => {
                if (res.result) {
                    this.showSuccessMessage = true;
                    this.isDisable = true;
                }
            }
        );
    }
    public cancel() {
        this.dialogRef.close();
    }
}
